import { render, staticRenderFns } from "./AfterSessionFeedback.vue?vue&type=template&id=72740f0f&scoped=true"
import script from "./AfterSessionFeedback.vue?vue&type=script&lang=js"
export * from "./AfterSessionFeedback.vue?vue&type=script&lang=js"
import style0 from "./AfterSessionFeedback.vue?vue&type=style&index=0&id=72740f0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72740f0f",
  null
  
)

export default component.exports